import { message } from 'antd';
import { addAndUpdateVendorSurfaceTreatment, getVendorSurfaceTreatment } from '../services/supplierApi';

export default {
  namespace: 'surface',

  state: {
    data: {}
  },
  effects: {
    *getVendorSurfaceTreatment(_, { call, put }) {
      const result = yield call(getVendorSurfaceTreatment);
      if (result.success) {
        yield put({
          type: 'updateState',
          payload: {
            data: {
              data: result.data || {}
            }
          }
        });
      } else {
        result.msg && message.error(result.msg);
      }
    },
    *addAndUpdateVendorSurfaceTreatment({ payload: { data, qid } }, { call }) {
      const result = yield call(addAndUpdateVendorSurfaceTreatment, data, qid);
      if (result.success) {
        message.success('操作成功');
      } else {
        result.msg && message.error(result.msg);
      }
      return result;
    },
  },
  reducers: {
    updateState(state, { payload: { data } }) {
      return {
        ...state,
        ...data
      };
    }
  }
};

